<div id="cover" *ngIf="projectService.loading()"></div>

<div class="section-page dashboard">
  <div class="container-fluid">
    <div class="projects-grid">
      <div class="project-card-wrap" *ngFor="let project of projectService?.getPermittedProjects(); let i = index"
        [style.animation-delay]="(i * 60) + 'ms'">
        <div class="project-card" [class.selected]="project?.project_id == commonDataObject.selectedProjectId"
          [class]="">
          <div class="card-header">
            <div class="card-avatar">
              {{ project.project_name?.charAt(0)?.toUpperCase() }}
            </div>
            <div class="card-title-group">
              <h5 class="card-project-name">{{ project.project_name?.toUpperCase() }}</h5>
              <span class="selected-badge" *ngIf="project?.project_id == commonDataObject.selectedProjectId">
                <i class="fas fa-circle" style="color: greenyellow;"></i>
                Active
              </span>
            </div>
          </div>

          <div class="card-body">
            <div class="info-row">
              <span class="info-icon">
                <i class="fas fa-user"></i>
              </span>
              <div class="info-content">
                <span class="info-label">Coordinator</span>
                <span class="info-value" style="margin-left: 20px;">{{ project.project_coordinator || '—' }}</span>
              </div>
            </div>
            <div class="info-row">
              <span class="info-icon">
                <i class="fas fa-user-group"></i>
              </span>
              <div class="info-content">
                <span class="info-label">Co-coordinator</span>
                <span class="info-value" style="margin-left: 20px;">{{ project.project_co_coordinator || '—' }}</span>
              </div>
            </div>
            <div class="info-row description-row">
              <span class="info-icon">
                <i class="fas fa-circle-info"></i>
              </span>
              <div class="info-content">
                <span class="info-label">Description</span>
                <span class="info-value project-description">{{ project.project_description || 'No description
                  provided.' }}</span>
              </div>
            </div>
          </div>

          <div class="card-hover-overlay">
            <button type="button" class="overlay-btn overlay-btn-ghost"
              (click)="$event.stopPropagation(); onProjectClick(project)">
              <i class="fas fa-circle-info"></i>
              More Details
            </button>
            <button type="button" class="overlay-btn overlay-btn-solid"
              (click)="$event.stopPropagation(); onReportClick(project)">
              <i class="fa-solid fa-chart-pie"></i>
              View Expenses
            </button>
          </div>
        </div>
      </div>

      <div class="empty-state" *ngIf="!projectService?.getPermittedProjects()?.length">
        <div class="empty-icon">
          <svg width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.2" viewBox="0 0 24 24">
            <path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z" />
          </svg>
        </div>
        <p class="empty-title">No projects found</p>
        <p class="empty-sub">You don't have access to any projects yet.</p>
      </div>
    </div>
  </div>
</div>